import MachineApi from "@/api/machinesApi";
import UserApi from "@/api/userApi";
import _ from "lodash";

const getUsersGroupToAddUpdate = (users, selectedUserIds, groupId) => {
  const res = [];
  try {
    for (const i in users) {
      const user = users[i];
      let add = false;
      let remove = false;

      const foundGroupUser = _.findIndex(user.Machine_Group_Ids, { Id: groupId }) > -1;
      const userIsSelected = selectedUserIds.indexOf(user.Id) > -1;

      add = userIsSelected && !foundGroupUser;
      remove = !userIsSelected && foundGroupUser;

      if (remove) {
        // Recupero tutti i gruppi dell'utente rimuovo quello corrente
        const updateGroupIds = user.Machine_Group_Ids.filter(item => item.Id !== groupId);
        res.push({
          Id: user.Id,
          Machine_Group_Ids: updateGroupIds
        });
      }

      if (add) {
        const newGroupIds = user.Machine_Group_Ids;
        newGroupIds.push({
          Id: groupId
        });

        res.push({
          Id: user.Id,
          Machine_Group_Ids: newGroupIds
        });
      }
    }
  } catch (e) {
    console.error(e);
  }
  return res;
};

export default {
  state: {
    machineList: null,
    machineFamiliesList: [],
    machineListSelected: {},
    machineGroupsList: [],
    machineGroupsListSelected: {},
    machineSettingsState: "",
    machineSelected: undefined
  },
  getters: {
    getMachineSelected: state => state.machineSelected,
    getMachineList: state => state.machineList,
    getMachineFamiliesList: state => state.machineFamiliesList,
    getMachineListSelected: state => state.machineListSelected,
    getMachineGroupsListSelected: state => state.machineGroupsListSelected,
    getMachineGroupsList: state => state.machineGroupsList,
    getMachineById: state => id => {
      return state.machineList.find(item => item.Id === id);
    },
    getMachineSettingsState: state => state.machineSettingsState
  },
  actions: {
    setMachineSelected({ commit }, args) {
      commit("SET_MACHINE_SELECTED", args);
    },
    resetGroups: ({ commit }) => {
      commit("RESET_MACHINE_GROUPS");
    },
    reset: ({ commit }) => {
      commit("RESET");
    },

    async setGroupsList({ commit, rootGetters }) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);

      let groups = [];
      // SET Groups
      const res = await api.getGroups({ skip: 0, limit: 1 });
      groups = res.result;
      if (res.total > res.result.length) {
        const res2 = await api.getGroups({ skip: 1, limit: res.total });
        groups = groups.concat(res2.result);
      }
      commit("MACHINEGROUPS_LIST", groups);
    },

    async setMachineFamiliesList({ commit, rootGetters }, vendorId) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);

      // SET MachineFamilies
      const res = await api.getMachineFamilies(vendorId);
      commit("MACHINEFAMILIES_LIST", res.result);
    },

    async setMachineGroupsListSelected({ rootGetters, state, commit }, args) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);

      const res = _.filter(state.machineGroupsList, function (item) {
        return item.Id === args;
      });

      const selected = res.length === 1 ? res[0] : {};

      if (selected.Id) {
        const users = await api.getUsersMachineGroupId(selected.Id, { skip: 0, limit: 1000 });
        selected["User_Ids"] = users;
      }

      commit("MACHINEGROUPS_LIST_SELECTED", selected);
    },

    async setMachineList({ commit, rootGetters }) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);

      // SET Machine for Settings
      let machines = [];
      // Get All Machines
      const res = await api.getMachines({ skip: 0, limit: 1 });
      machines = res.result;
      if (res.total > res.result.length) {
        const res2 = await api.getMachines({ skip: 1, limit: res.total });
        machines = machines.concat(res2.result);
      }

      commit("MACHINE_LIST", machines);
    },

    setMachineListSelected({ state, commit }, value) {
      const selected = _.filter(state.machineList, function (item) {
        return item.Id === value;
      });

      commit("MACHINE_LIST_SELECTED", !!selected.length === 1 ? selected[0] : {});
    },

    async saveMachineActivation({ dispatch, rootGetters }, machine) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);

      try {
        const res_machine = await api.saveMachineActivation(machine);

        if (res_machine.data.machine_id) {
          // saved OK
          dispatch(
            "Alert/setVal",
            {
              message: "",
              result: {
                label: "machine_settings.machine_activation_ok",
                Id: res_machine.machine_id
              }
            },
            { root: true }
          );
          return res_machine;
        } else {
          // error
          dispatch(
            "Alert/Errors/setVal",
            {
              message: "",
              result: { label: "errors.machine_activation_error", Id: res_machine.machine_id }
            },
            { root: true }
          );
        }
      } catch (e) {
        return null;
      }
    },

    async saveMachineGroups({ state, commit, dispatch, rootGetters }, group) {
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);
      const userApi = new UserApi(rootGetters["User/getUser"].OrganizationCode);
      const machineGroup = group.groupData;

      // Group data to save
      const add_upd_group = {
        Name: machineGroup.Name,
        OrganizationCode: rootGetters["User/getUser"].OrganizationCode
      };

      // Machines to save
      const add_upd_machines = { Machine_Ids: [] };
      add_upd_machines.Machine_Ids = group.selectedMachineIds.map(id => {
        return { Id: id };
      });

      // UPDATE
      let res = null;
      if (machineGroup.Id) {
        try {
          // Save group
          await api.updateMachineGroup(machineGroup.Id, add_upd_group);
          // Save machines group
          await api.updateMachinesOnGroup(machineGroup.Id, add_upd_machines);

          // Update list in store
          const new_list = _.reject(state.machineGroupsList, function (g) {
            return g.Id === machineGroup.Id;
          });
          Object.assign(machineGroup, add_upd_machines);
          new_list.unshift(machineGroup);
          commit("MACHINEGROUPS_LIST", new_list);

          dispatch(
            "Alert/setVal",
            {
              message: "",
              result: { label: "machine_settings.group_saved_ok", Id: machineGroup.Id }
            },
            { root: true }
          );

          res = { data: machineGroup };
        } catch (e) {
          return null;
        }
      }
      // NEW
      else {
        try {
          const res_group = await api.saveMachineGroup(add_upd_group);

          if (res_group.Id) {
            // Save ok
            machineGroup.Id = res_group.Id;

            // Add machines
            try {
              await api.updateMachinesOnGroup(machineGroup.Id, add_upd_machines);
              // Update list in store
              Object.assign(machineGroup, add_upd_machines);
            } catch (e) {
              console.error(e);
            }

            const new_list = _.clone(state.machineGroupsList);
            new_list.unshift(machineGroup);
            commit("MACHINEGROUPS_LIST", new_list);

            dispatch(
              "Alert/setVal",
              {
                message: "",
                result: { label: "machine_settings.group_saved_ok", Id: machineGroup.Id }
              },
              { root: true }
            );

            res = { data: machineGroup };
          }
        } catch (e) {
          return null;
        }
      }

      // Add machine group to users
      const updateUserGroups = async (userId, newGroupIds) => {
        try {
          await userApi.updateUserGroups(userId, {
            Machine_Group_Ids: newGroupIds
          });
          return true;
        } catch (e) {
          return false;
        }
      };

      // Update Users group
      const add_upd_users = getUsersGroupToAddUpdate(
        group.users,
        group.selectedUserIds,
        machineGroup.Id
      );

      // Add users
      const gropuAddedToUsers = add_upd_users.map(add_upd_user =>
        updateUserGroups(add_upd_user.Id, add_upd_user.Machine_Group_Ids)
      );
      await Promise.all(gropuAddedToUsers);
      // End save users
      return res;
    },

    async deleteMachineGroup({ state, commit, dispatch, rootGetters }, groupId) {
      // DELETE
      const api = new MachineApi(rootGetters["User/getUser"].OrganizationCode);
      try {
        await api.deleteMachineGroup(groupId);

        const new_list = _.reject(state.machineGroupsList, function (g) {
          return g.Id === groupId;
        });

        // Update list
        commit("MACHINEGROUPS_LIST", new_list);

        // Alert ok
        dispatch(
          "Alert/setVal",
          { message: "", result: { label: "machine_settings.group_delete_ok" } },
          { root: true }
        );

        return true;
      } catch (e) {
        return null;
      }
    },

    setMachineSettingsState({ commit }, args) {
      commit("MACHINE_SETTINGS_STATE", args);
    }
  },
  mutations: {
    SET_MACHINE_SELECTED: (state, payload) => {
      state.machineSelected = payload;
    },
    MACHINEGROUPS_LIST: (state, list) => {
      state.machineGroupsList = list;
    },
    MACHINEFAMILIES_LIST: (state, list) => {
      state.machineFamiliesList = list;
    },
    MACHINEGROUPS_LIST_SELECTED: (state, selected) => {
      state.machineGroupsListSelected = selected;
    },
    MACHINE_LIST: (state, list) => {
      state.machineList = list;
    },
    MACHINE_LIST_SELECTED: (state, selected) => {
      state.machineListSelected = selected;
    },
    MACHINE_SETTINGS_STATE: (state, payload) => {
      state.machineSettingsState = payload;
    },
    RESET_MACHINE_GROUPS: state => {
      state.machineGroupsList = [];
    },
    RESET: state => {
      state.machineListSelected = {};
      state.machineGroupsListSelected = {};
      state.machineSettingsState = "";
    }
  },
  namespaced: true,
  modules: {}
};
